/* eslint-disable no-undef */
import React from "react"
import TopBar from "../template/TopBar"
import Footer from "../template/Footer"
import SideNav from "../template/SideNav"
import { Loader, RangPicker } from "../../config/Svgicon"
import Pagination from "react-js-pagination"
import _ from "lodash"
import { usersService } from "../../_services/usersService"
import ResponseFilter from "../../config/response-handler"
import { CSVLink } from "react-csv"
import { Select, Empty } from "antd"
import moment from "moment"
import DateRangePicker from "react-bootstrap-daterangepicker"
// you will also need the css that comes with bootstrap-daterangepicker
import "bootstrap-daterangepicker/daterangepicker.css"

const { Option } = Select

class AdminReports extends React.Component {
  constructor(props) {
    super(props)
    let date = new Date()
    let y = date.getFullYear()
    let m = date.getMonth()
    let firstDay = new Date(y, m, 1).getTime()
    let lastDay = new Date(y, m, 31).getTime()
    this.state = {
      hideSale: false,
      isOpenEvent: false,
      isOpenTicket: false,
      limit: 9999999,
      sortOrder: "desc",
      sortBy: "created",
      page: 1,
      eventId: "",
      ticketId: "",
      ticketIdShow: "",
      startDate: firstDay,
      endDate: lastDay,
      search: "",
      search1: "",
      loader: false,
      eventList: [],
      ticketList: [],
      orderList: [],
      orderListCSV: [],
      eventnameShow: "",
      ticketnameShow: "",
      pageVisitorsShow: "",
      pageVisitors: "",
      promotersList: [],
      totalCount: "",
      promoterId: "",
      timeout: false,
    }
  }

  componentDidMount() {
    console.log("role**:  " + localStorage.getItem("role"))
    console.log(this.state)
    if (
      localStorage.getItem("role") != 4 &&
      localStorage.getItem("isAccountDetailsExists") == "false" &&
      localStorage.getItem("role") != 2
    ) {
      console.log("redirecting no account")
      this.props.history.push("/account-settings")
    }
    if (localStorage.getItem("role") == 2) {
      console.log("redirecting 2-role")
      this.props.history.push("/events-feed")
    }
    // if (localStorage.getItem('role') == 4) {
    //   this.props.history.push('/admin');
    // }
    document.title = "Reports | Farechild"
    this.getOrderDetails(1)
    this.getEventList()
    this.getPromotersList()
  }

  // handleSearch = (e) => {
  //   this.setState({ loader: false });
  //   let orderId1 = e.target.value.split('#').join('%23');
  //   this.setState({ search: orderId1, page: 1, search1: e.target.value }, () =>
  //     this.getOrderDetails()
  //   );
  // };

  //debounced search handler
  handleSearch = (e) => {
    this.setState({ loader: false, search1: e.target.value }, () => {
      this.setState({ loader: false })
      if (this.state.timeout) {
        clearTimeout(this.state.timeout)
      }
      this.setState({
        timeout: setTimeout(() => {
          let orderId1 = this.state.search1.split("#").join("%23")
          this.setState({ search: orderId1, page: 1 }, () => this.getOrderDetails())
        }, 500),
      })
    })
  }

  changeLimit = (e) => {
    this.setState({ limit: e, page: 1 }, () => this.getOrderDetails())
  }

  handlePageChange = (page) => {
    this.setState({ page: page, loader: true }, () => this.getOrderDetails())
  }

  handleSort = (e) => {
    this.setState(
      {
        loader: false,
        page: 1,
        sortBy: e,
        sortOrder: this.state.sortOrder === "desc" ? "asc" : "desc",
      },
      () => this.getOrderDetails()
    )
  }

  getPromotersList = () => {
    let params = `sortBy=${"nameLower"}&sortOrder=${"desc"}`
    const accessToken = localStorage.getItem("accessToken")
    this.setState({ loader: true })
    usersService.getPromoters(params, accessToken).then((res) => {
      let { status, resData } = ResponseFilter(res)
      if (status) {
        this.setState({
          loader: false,
          promotersList: resData.result,
          totalCount: resData.count,
        })
      } else {
        this.setState({ loader: false })
      }
    })
  }

  getOrderDetails = (check) => {
    this.setState({ loader: true })
    let params = `userId=${this.state.promoterId}&eventId=${this.state.eventId}&ticketId=${
      this.state.ticketId
    }&startDate=${this.state.startDate}&endDate=${this.state.endDate}&search=${this.state.search}&sortBy=${
      this.state.sortBy
    }&sortOrder=${this.state.sortOrder}&page=${this.state.page - 1}&limit=${this.state.limit}`
    console.log('PARAMS: ',params); 
    usersService.orderReport(params).then((res) => {
      this.setState({ loader: false })
      console.log('RESPONSE: ',res); 
      let { status, resData } = ResponseFilter(res)
      if (status) {
        this.getticketList()
        this.setState(
          {
            orderList: resData.result,
            totalCount: resData.count,
          },
          () => this.getOrderDetailsCSV(check, this.state.totalCount)
        )
      }
    })
  }

  getOrderDetailsCSV = (check, limit) => {
    let params = `userId=${this.state.promoterId}&eventId=${this.state.eventId}&ticketId=${
      this.state.ticketId
    }&startDate=${this.state.startDate}&endDate=${this.state.endDate}&search=${this.state.search}&sortBy=${
      this.state.sortBy
    }&sortOrder=${this.state.sortOrder}&limit=${limit + 1}`

    usersService.orderReport(params).then((res) => {
      let { status, resData } = ResponseFilter(res)
      if (status) {
        if (check) {
          this.setState({ pageVisitorsShow: resData.pageVisitors })
        }
        let fees = 0
        let subTotal = 0
        let total = 0
        resData.result.map((details) => {
          if (details.ticketDetails.status != 3) {
            fees = fees + parseFloat(details.fees)
            subTotal = subTotal + parseFloat(details.subtotal)
            total = total + parseFloat(details.grandTotal)
          }
        })
        console.log('resdata',resData);
        this.setState({
          orderListCSV: resData.result,
          totalCount: resData.count,
          Sales: parseFloat(resData.Sales).toFixed(2),
          ticketSales: resData.ticketSales,
          pageVisitors: resData.pageVisitors,
          ticketsSubtotal: resData.totalTicketSubtotal,
          feeTotal: resData.totalFees,
          taxes:resData.taxes,
          discountTotal: resData.totalDiscounts,
        })
      }
    })
  }

  getEventList = () => {
    const currentTimeZoneName = Intl.DateTimeFormat().resolvedOptions().timeZone

    var obj = {
     // currentTimeZoneName: currentTimeZoneName,
      createdBy: this.state.promoterId,  
      //shortForm: true,
    }
    
    console.log('GET EVENTS OBJ',obj);
    usersService.eventList(obj).then((res) => {
      let { status, resData } = ResponseFilter(res);
      console.log('EVENT RES',res);
      if (status) {
        this.setState({
          eventList: resData.result,
        })
      }
    })
  }

  eventFilter = (id) => {
    const orderTicketList = this.state.eventList.filter((e) => e._id === id)
    if (id !== "") {
      this.setState({ eventnameShow: orderTicketList[0].eventName })
    } else {
      this.setState({ eventnameShow: "" })
    }

    this.setState({ hideSale: false })
    this.setState(
      {
        eventId: id ? id : "",
        ticketId: "",
        ticketIdShow: "",
        ticketList: [],
        ticketName: "",
        ticketnameShow: "",
      },
      () => this.getOrderDetails(1)
    )
  }

  promoterFilter = (id) => {
    this.setState(
      {
        promoterId: id || "",
      },
      () => {
        this.getOrderDetails(1)
        this.getEventList();
      }
    )
  }

  getticketList = () => {
    let obj = {
      eventId: this.state.eventId,
    }
    usersService.ticketList(obj).then((res) => {
      let { status, resData } = ResponseFilter(res)
      if (status) {
        this.setState({
          ticketList: resData.result,
        })
      }
    })
  }

  ticketFilter = (id) => {
    const orderTicketList = this.state.ticketList.filter((e) => e._id === id)

    if (orderTicketList.length !== 0) {
      this.setState({ ticketnameShow: orderTicketList[0].ticketName })
      if (
        orderTicketList[0].price == "null" ||
        orderTicketList[0].price == null ||
        orderTicketList[0].price == 0 ||
        orderTicketList[0].price == "0"
      ) {
        this.setState({ hideSale: true })
      } else {
        this.setState({ hideSale: false })
      }
    } else {
      this.setState({ ticketnameShow: "" })
      this.setState({ hideSale: false })
    }

    this.setState(
      {
        ticketId: id !== "1" && id ? id : "",
        ticketIdShow: id ? id : "",
      },
      () => this.getOrderDetails()
    )
  }

  showDropdown = () => {
    this.setState({ isOpenEvent: true })
    document.addEventListener("click", this.hideDropdown)
  }
  hideDropdown = () => {
    this.setState({ isOpenEvent: false })
    document.removeEventListener("click", this.hideDropdown)
  }

  ticketShowDropdown = () => {
    this.setState({ isOpenTicket: true })
    document.addEventListener("click", this.ticketHideDropdown)
  }
  ticketHideDropdown = () => {
    this.setState({ isOpenTicket: false })
    document.removeEventListener("click", this.ticketHideDropdown)
  }

  handleCancel = (event, picker) => {
    this.setState(
      {
        event: "",
        pageNo: 1,
        startDate: "",
        endDate: "",
      },
      () => {
        this.getOrderDetails()
      }
    )
    picker.element.val("")
  }

  handleRangePicker = (event, picker) => {
    var date = new Date(picker.endDate)
    picker.element.val(picker.startDate.format("MM/DD/YYYY") + " - " + picker.endDate.format("MM/DD/YYYY"))

    this.setState(
      {
        pageNo: 1,
        startDate: !_.isEmpty(picker.startDate) ? new Date(picker.startDate).getTime() : "",
        endDate: !_.isEmpty(picker.endDate) ? new Date(picker.endDate).getTime() : "",
        // endDate: !_.isEmpty(picker.endDate)
        //   ? date.setUTCHours(date.getDate())
        //   : '',
      },
      () => {
        this.getOrderDetails()
      }
    )
  }

  getCouponList = (id, eventId) => {
    let obj = {
      eventId: eventId,
      couponId: id,
    }
    this.setState({ loader: true })
    usersService.couponList(obj).then((res) => {
      let { status, resData } = ResponseFilter(res)
      if (status) {
        this.setState({ loader: false })

        if (resData.result.length !== 0) {
          let { _id, couponName, discount, discountType, selectedTickets } = resData.result[0]

          this.setState(
            {
              couponID: _id,
              couponDetails: resData.result,
              couponName,
              discount,
              discountType,
              selectedTickets,
            },
            () => this.validate()
          )
        } else {
          this.setState({
            couponNameErrorMsg: "Please enter valid promo code.",
          })
        }
      } else {
        this.setState({ loader: false })
      }
    })
  }

  getCouponAmount = (id, eventId) => {
    let price = 0
    this.getCouponList(id, eventId)
    return price
  }

  render() {
    let { loader, orderList, orderListCSV } = this.state
    var today = moment(new Date()).format("MM-DD-YYYY")
    let startDate = new Date(this.state.startDate)
    let startDateString = startDate.getMonth() + 1 + "/" + startDate.getDate() + "/" + startDate.getFullYear()
    let endDate = new Date(this.state.endDate)
    let endDateString = endDate.getMonth() + 1 + "/" + endDate.getDate() + "/" + endDate.getFullYear()
    console.log("start date: " + startDateString, "\n end date: " + endDateString)
    const headers = [
      { label: "Order Id", key: "OrderId" },
      { label: "First", key: "First" },
      { label: "Last", key: "Last" },
      { label: "Email", key: "Email" },
      { label: "Phone", key: "Phone" },
      { label: "Address", key: "Address" },
      { label: "Ticket", key: "Ticket" },
      { label: "QTY.", key: "QTY" },
      { label: "Ticket Amount", key: "Amount" },
      { label: "Tickets Subtotal", key: "TicketSubtotal" },
      { label: "Fee Subtotal", key: "FeeSubtotal" },
      { label: "Discount Subtotal", key: "DiscountSubtotal" },
      { label: "Total Fees", key: "Fees" },
      { label: "Total Discount", key: "DiscountAmount" },
      { label: "Promo applied", key: "DiscountCode" },
      { label: "Order Total", key: "Total" },
      { label: "Purchase Date", key: "Date" },
      { label: "Status", key: "Status" },
    ]

    let order = orderListCSV.map((or) => ({
      OrderId: or.orderId ? or.orderId : "-",
      First: or.contactInformation ? or.contactInformation.firstName : "-",
      Last: or.contactInformation ? or.contactInformation.lastName : "-",
      Email: or.contactInformation ? or.contactInformation.email : "-",
      Phone: or.contactInformation.phone ? `+${or.contactInformation.phone}` : "-",
      Address: or.billingInformation.address1
        ? `${or.billingInformation.address1},${or.billingInformation.city},${or.billingInformation.state},${or.billingInformation.zipCode}`
        : "-",
      Ticket: or.ticketDetails ? or.ticketDetails.ticketName : "-",
      QTY: or.ticketDetails ? or.ticketDetails.ticketQuantity : "-",
      Amount: or.ticketDetails.ticketPrice !== "0" ? "$" + Number(or.ticketDetails.ticketPrice).toFixed(2) : "Free",
      TicketSubtotal:
        or.ticketDetails.ticketSubtotal !== "0" ? "$" + Number(or.ticketDetails.ticketSubtotal).toFixed(2) : "-",
      FeeSubtotal: or.ticketDetails.feePortion !== "0" ? "$" + Number(or.ticketDetails.feePortion).toFixed(2) : "-",
      DiscountSubtotal:
        or.ticketDetails.discountPortion !== "0" ? "$" + Number(or.ticketDetails.discountPortion).toFixed(2) : "-",
      Fees: or.fees ? `$${Number(or.fees ? or.fees : 0).toFixed(2)}` : `$${Number(0).toFixed(2)}`,
      DiscountAmount:
        or.ticketDetails.ticketPrice != "0"
          ? or.grandTotal == 0
            ? `$${Number(or.ticketDetails.ticketPrice ? or.ticketDetails.ticketPrice : 0).toFixed(2)}`
            : `$${Number(or.discountedPrice ? or.discountedPrice : 0).toFixed(2)}`
          : `$${Number(0).toFixed(2)}`,
      DiscountCode:
        or.ticketDetails.ticketPrice != "0"
          ? or.grandTotal == 0
            ? "Yes"
            : `${or.discountedPrice ? "Yes" : "No"}`
          : "No",

      Total: or.grandTotal ? `$${Number(or.grandTotal ? or.grandTotal : 0).toFixed(2)}` : `$${Number(0).toFixed(2)}`,

      Date: moment(or.created).format("MM/DD/YYYY"),
      Status: or.status ? or.status : "-",
    }))

    return (
      <div className="dark-sidebar">
        {loader ? <Loader /> : null}
        <div className="main-container">
          <div className="container-fluid page-body-wrapper">
            <nav className="navbar fixed-top">
              <div className="navbar-menu-container d-flex align-items-center justify-content-center">
                <div className="sub-heading">
                  <h4 className="page-title ">Reports</h4>
                </div>
                <div className="text-center navbar-brand-container align-items-center justify-content-center">
                  <a className="brand-logo" href="/">
                    <img src={require("../../assets/images/mobile-logo.png")} alt="" className="mb-3" />
                  </a>
                </div>

                <TopBar {...this.props} />
              </div>
            </nav>

            <SideNav />
            <div className="main-panel">
              <div className="content-wrapper manage-event">
                <div className="row ">
                  <div className="col-md-12">
                    <div className="card card-margin">
                      <div className="card-header">
                        <h5 className="card-title">Run a Report</h5>
                      </div>
                      <div className="card-body">
                        <div className="card-info">Choose from the options below to run a report.</div>
                        <div className="row">
                          <div className="col-md-4 col-sm-12 mb-2 mb-lg-0 mb-md-0">
                            <div className="input-group  rang-picker">
                              <DateRangePicker
                                initialSettings={{
                                  autoUpdateInput: true,
                                  locale: {
                                    cancelLabel: "Clear",
                                  },
                                  startDate: startDateString,
                                  endDate: endDateString,
                                }}
                                onApply={this.handleRangePicker}
                                onCancel={this.handleCancel}
                              >
                                <input
                                  type="text"
                                  className="form-control bg-white"
                                  name="date1"
                                  readOnly
                                  id="date1"
                                  placeholder="Select Date Range"
                                />
                              </DateRangePicker>
                              <span className="input-group-text">
                                <RangPicker />
                              </span>
                            </div>
                          </div>

                          <div className="col-md-6 ml-2">
                            <div className="d-flex flex-row order-select">
                              <div>
                                <Select
                                  showSearch
                                  style={{ width: 200 }}
                                  placeholder="Select an Event"
                                  optionFilterProp="children"
                                  className="order-filter"
                                  onFocus={this.onFocus}
                                  onBlur={this.onBlur}
                                  onSearch={this.onSearch}
                                  onChange={this.eventFilter}
                                >
                                  <Option value="">All</Option>
                                  {!_.isEmpty(this.state.eventList)
                                    ? this.state.eventList.map((item) => (
                                        <Option value={item._id}>{item.eventName}</Option>
                                      ))
                                    : ""}
                                </Select>
                              </div>
                              <div className="ml-md-3 mt-3 mt-md-0">
                                <Select
                                  showSearch
                                  style={{ width: 200 }}
                                  placeholder="Select Ticket Type"
                                  optionFilterProp="children"
                                  className="order-filter"
                                  onFocus={this.onFocus}
                                  onBlur={this.onBlur}
                                  onSearch={this.onSearch}
                                  value={this.state.ticketIdShow ? this.state.ticketIdShow : "Select Ticket Type"}
                                  onChange={this.ticketFilter}
                                  disabled={!_.isEmpty(this.state.ticketList) ? false : true}
                                >
                                  <Option value="1">All</Option>
                                  {!_.isEmpty(this.state.ticketList)
                                    ? this.state.ticketList.map((item) => (
                                        <Option value={item._id}>{item.ticketName}</Option>
                                      ))
                                    : ""}
                                </Select>
                              </div>
                              <div className="ml-md-3 mt-3 mt-md-0">
                                <Select
                                  showSearch
                                  style={{ width: 200 }}
                                  placeholder="Select a Promoter"
                                  optionFilterProp="children"
                                  className="order-filter"
                                  onFocus={this.onFocus}
                                  onBlur={this.onBlur}
                                  onSearch={this.onSearch}
                                  onChange={this.promoterFilter}
                                >
                                  <Option value="">All</Option>
                                  {!_.isEmpty(this.state.promotersList)
                                    ? this.state.promotersList
                                        // .filter(
                                        //   (event) =>
                                        //     event.status === 2 ||
                                        //     event.status === 3
                                        // )
                                        .map((item) => <Option value={item._id}>{item.name}</Option>)
                                    : ""}
                                </Select>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-4 col-md-4 col-sm-12">
                    <div className="card card-margin">
                      <div className="card-body p-0">
                        <div className="widget-20">
                          <div className="widget-20-header">
                            <div className="widget-20-content">
                              <h5 className="widget-20-title">Ticket Sales</h5>
                              <span className="widget-20-info">
                                {this.state.ticketnameShow && this.state.ticketnameShow !== "" ? (
                                  this.state.ticketnameShow
                                ) : (
                                  <>
                                    {this.state.eventnameShow && this.state.eventnameShow !== ""
                                      ? this.state.eventnameShow
                                      : "All"}
                                  </>
                                )}
                              </span>
                            </div>
                            <h3 className="widget-20-figure">{this.state.ticketSales ? this.state.ticketSales : 0}</h3>
                          </div>
                          {/* <div className="widget-20-chart">
                            <img
                              src={require('../../assets/images/red-graph.png')}
                              className="img-fluid"
                              alt=""
                            />
                          </div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-4 col-sm-12">
                    <div className="card card-margin">
                      <div className="card-body p-0">
                        <div className="widget-20">
                          <div className="widget-20-header">
                            <div className="widget-20-content">
                              <h5 className="widget-20-title">Sales</h5>
                              <span className="widget-20-info">
                                {this.state.ticketnameShow && this.state.ticketnameShow !== "" ? (
                                  this.state.ticketnameShow
                                ) : (
                                  <>
                                    {this.state.eventnameShow && this.state.eventnameShow !== ""
                                      ? this.state.eventnameShow
                                      : "All"}
                                  </>
                                )}
                              </span>
                            </div>
                            <h3 className="widget-20-figure">
                              $
                              {this.state.hideSale ? (
                                "0"
                              ) : (
                                <>
                                  {!isNaN(this.state.Sales) ||
                                  this.state.Sales !== NaN ||
                                  this.state.Sales ||
                                  this.state.Sales !== "NaN"
                                    ? this.state.Sales
                                    : "0.00"}
                                </>
                              )}
                            </h3>
                          </div>
                          <div className="widget-20-detail">
                            <div className="widget-20-content">
                              <h5 className="widget-20-subtitle">Ticket Subtotal</h5>
                            </div>
                            <div className="widget-20-figure">
                              <h4>${this.state.ticketsSubtotal}</h4>
                            </div>
                          </div>
                          <div className="widget-20-detail">
                            <div className="widget-20-content">
                              <h5 className="widget-20-subtitle">Fee Subtotal</h5>
                            </div>
                            <div className="widget-20-figure">
                              <h4>${this.state.feeTotal}</h4>
                            </div>
                          </div>
                          <div className="widget-20-detail">
                            <div className="widget-20-content">
                              <h5 className="widget-20-subtitle">Discount Subtotal</h5>
                            </div>
                            <div className="widget-20-figure">
                              <h4>${this.state.discountTotal}</h4>
                            </div>
                          </div>
                          <div className="widget-20-detail">
                            <div className="widget-20-content">
                              <h5 className="widget-20-subtitle">Taxes</h5>
                            </div>
                            <div className="widget-20-figure">
                              <h4>${this.state.taxes}</h4>
                            </div>
                          </div>
                          {/* <div className="widget-20-chart">
                            <img
                              src={require('../../assets/images/green-bar-graph.png')}
                              className="img-fluid"
                            />
                          </div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <div className="col-lg-4 col-md-4 col-sm-12">
                    <div className="card card-margin mb-4 mb-lg-0 mb-md-0">
                      <div className="card-body p-0">
                        <div className="widget-20">
                          <div className="widget-20-header">
                            <div className="widget-20-content">
                              <h5 className="widget-20-title">Page Visitors</h5>
                              <span className="widget-20-info">
                                {this.state.eventnameShow &&
                                this.state.eventnameShow !== ''
                                  ? this.state.eventnameShow
                                  : 'All'}
                              </span>
                            </div>
                            <h3 className="widget-20-figure">
                              {this.state.pageVisitorsShow
                                ? this.state.pageVisitorsShow
                                : 0}
                            </h3>
                          </div>
                         
                        </div>
                      </div>
                    </div>
                  </div>*/}
                </div>

                <div className="row card-margin">
                  <div className="col-lg-12 card-margin">
                    <div className="card">
                      <div className="card-header justify-content-between">
                        <h5 className="card-title col-md-7">Results</h5>
                        <div className="col-md-4 col-sm-4 text-md-right">
                          <input
                            onKeyPress={(e) => {
                              if (e.key === "Enter") e.preventDefault()
                            }}
                            className="form-control search-box"
                            name="search"
                            placeholder="Search"
                            type="search"
                            value={this.state.search1}
                            onChange={this.handleSearch}
                            style={{ marginBottom: "0"}}
                          />
                        </div>
                        {order.length == 0 ? (
                          <div className="col-md-2">
                            <button className="btn btn-sm btn-dark" disabled>
                              Export Results
                            </button>
                          </div>
                        ) : (
                          <CSVLink
                            filename={`Reports-Results_${today ? today : ""}.csv`}
                            data={order}
                            headers={headers}
                            className="btn btn-sm btn-dark"
                          >
                            Export Results
                          </CSVLink>
                        )}
                      </div>
                      <div className="card-body">
                        <div className="table-responsive">
                          <table id="example" className="table table-striped table-bordered">
                            <thead>
                              <tr>
                                <th className="p-3">Order #</th>
                                <th className="p-3">First Name</th>
                                <th className="p-3">Last Name</th>
                                <th className="p-3">Email</th>
                                <th className="p-3">Phone</th>
                                <th className="p-3">Address</th>
                                {/* <th className="p-3">Ticket</th>
                                <th className="p-3">QTY.</th>
                                <th className="p-3">Ticket Amount</th>
                                <th className="p-3">Ticket Subtotal</th> */}
                                <th className="p-3">Subtotal</th>
                                {/* <th className="p-3">Fees</th> */}
                                {/* <th className="p-3">Discount</th> */}
                                <th className="p-3">Fees</th>
                                <th className="p-3">Vaccine Card</th>  
                                <th className="p-3">Taxes</th>
                                <th className="p-3">Discount</th>
                                <th className="p-3">Promo Applied</th>
                                <th className="p-3">Order Total</th>
                                <th className="p-3">Purchase Date</th>
                                <th className="p-3">Ticket Status</th>
                              </tr>
                            </thead>
                            <tbody>
                              {!_.isEmpty(orderList) ? (
                                <React.Fragment>
                                  {orderList.map((item, i) => {
                                    return (
                                      <tr key={i}>
                                        <td>{item.orderId ? item.orderId : "-"}</td>
                                        <td>
                                          {item.contactInformation.firstName ? item.contactInformation.firstName : "_"}
                                        </td>
                                        <td>
                                          {item.contactInformation.lastName ? item.contactInformation.lastName : "_"}
                                        </td>
                                        <td>{item.contactInformation.email ? item.contactInformation.email : "_"}</td>
                                        <td>
                                          {item.contactInformation.phone ? `+${item.contactInformation.phone}` : "_"}
                                        </td>
                                        <td>
                                          {item.billingInformation.address1
                                            ? `${item.billingInformation.address1}, ${item.billingInformation.city}, ${item.billingInformation.state}, ${item.billingInformation.zipCode}`
                                            : "_"}
                                        </td>
                                        <td>
                                          {item.subtotal}
                                        </td>
                                        {/* <td>{item.ticketDetails ? item.ticketDetails.ticketName : ""}</td>
                                        <td>{item.ticketDetails ? item.ticketDetails.ticketQuantity : ""}</td>
                                        <td>
                                          {item.ticketDetails.ticketPrice != "0"
                                            ? `$${Number(item.ticketDetails.ticketPrice).toFixed(2)}`
                                            : "Free"}
                                        </td>
                                        <td>
                                          {" "}
                                          {item.ticketDetails.ticketSubtotal
                                            ? `$${Number(item.ticketDetails.ticketSubtotal).toFixed(2)}`
                                            : `$${Number(0).toFixed(2)}`}
                                        </td>
                                        <td>
                                          {" "}
                                          {item.ticketDetails.feePortion
                                            ? `$${Number(item.ticketDetails.feePortion).toFixed(2)}`
                                            : `$${Number(0).toFixed(2)}`}
                                        </td> */}
                                        {/* <td>
                                          {" "}
                                          {item.ticketDetails.discountPortion
                                            ? `$${Number(item.ticketDetails.discountPortion).toFixed(2)}`
                                            : `$${Number(0).toFixed(2)}`}
                                        </td> */}
                                        <td>
                                          {" "}
                                          {item.fees ? `$${Number(item.fees).toFixed(2)}` : `$${Number(0).toFixed(2)}`}
                                        </td>
                                        <td>
                                          {item?.isReportRequired[0] ? (
                                            item.vaccinationCertificate.length ? (
                                              <a href={item.vaccinationCertificate[0]} target="_blank">
                                                View Certificate
                                              </a>
                                            ) : (
                                              "Will provide negative test"
                                            )
                                          ) : (
                                            ""
                                          )}
                                        </td>
                                        <td>
                                          {item?.taxes ?'$'+item.taxes.toFixed(2): (
                                            ""
                                          )}
                                        </td>
                                        {/* <td>
                                          {item.ticketDetails.ticketPrice != 0 ? (
                                            <>
                                              {item.grandTotal == 0 ? (
                                                <>
                                                  {item.ticketDetails.ticketPrice
                                                    ? `$${Number(item.ticketDetails.ticketPrice).toFixed(2)}`
                                                    : `$${Number(0).toFixed(2)}`}
                                                </>
                                              ) : (
                                                <>
                                                  {item.discountedPrice
                                                    ? `$${Number(item.discountedPrice).toFixed(2)}`
                                                    : `$${Number(0).toFixed(2)}`}
                                                </>
                                              )}
                                            </>
                                          ) : (
                                            `$${Number(0).toFixed(2)}`
                                          )}
                                        </td> */}

                                        <td>
                                          {item.discountedPrice}
                                        </td>
                                        <td>{item.couponName ? item.couponName : ""}</td>
                                        <td>
                                          {item.grandTotal
                                            ? `$${Number(item.grandTotal).toFixed(2)}`
                                            : `$${Number(0).toFixed(2)}`}
                                        </td>
                                        <td>{item.created ? moment(item.created).format("MM/DD/YYYY") : ""}</td>
                                        {item.status === 1 && item.ticketDetails.status === 1 ? (
                                          <React.Fragment>
                                            {item.ticketDetails.ticketPrice === "0" ||
                                            item.cardLastFourDigit === undefined ||
                                            item.cardLastFourDigit === "" ? (
                                              <td style={{ width: 150 }}>
                                                {item.eventStatus === 2 ? <>Upcoming</> : "_"}
                                              </td>
                                            ) : (
                                              <td style={{ width: 150 }}>
                                                {item.eventStatus === 2 ? <>Upcoming</> : "_"}
                                              </td>
                                            )}
                                          </React.Fragment>
                                        ) : (
                                          <React.Fragment>
                                            {item.ticketDetails.status === 3 ? <td>Refunded</td> : <td>Cancelled</td>}
                                          </React.Fragment>
                                        )}
                                      </tr>
                                    )
                                  })}
                                </React.Fragment>
                              ) : (
                                ""
                              )}
                            </tbody>
                          </table>
                        </div>
                        {!_.isEmpty(orderList) ? (
                          ""
                        ) : (
                          <div className="text-center">
                            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                          </div>
                        )}

                        <div className="card-footer bg-white">
                          <div className="d-flex align-items-end justify-content-between flex-column flex-sm-row mt-4">
                            {!_.isEmpty(orderList) ? (
                              <p className="mb-3 mb-sm-0">
                                Showing{" "}
                                {this.state.page === 1 ? (
                                  <React.Fragment>1</React.Fragment>
                                ) : (
                                  this.state.page * this.state.limit - this.state.limit + 1
                                )}{" "}
                                to{" "}
                                {this.state.orderList
                                  ? this.state.orderList.length === this.state.limit
                                    ? this.state.page * this.state.limit - this.state.limit + this.state.limit
                                    : this.state.page * this.state.limit -
                                      this.state.limit +
                                      this.state.orderList.length
                                  : ""}{" "}
                                of {this.state.totalCount} entries
                              </p>
                            ) : (
                              <p className="mb-3 mb-dm-0">Showing 0 to 0 of 0 entries</p>
                            )}
                            <nav className="pagination-nav">
                              <ul>
                                <Pagination
                                  hideFirstLastPages={true}
                                  itemClassPrev="page-change"
                                  prevPageText="Previous"
                                  itemClassNext="page-change"
                                  nextPageText="Next"
                                  activePage={this.state.page}
                                  itemsCountPerPage={this.state.limit}
                                  totalItemsCount={this.state.totalCount}
                                  pageRangeDisplayed={3}
                                  onChange={this.handlePageChange}
                                />
                              </ul>
                            </nav>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Footer />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default AdminReports
